// src/index.tsx

import * as React from 'react';
// @ts-ignore
import ReactDOM from 'react-dom/client';
// @ts-ignore
import { BrowserRouter } from 'react-router-dom';
// @ts-ignore
import { ThemeProvider } from '@mui/material/styles';
// @ts-ignore
import CssBaseline from '@mui/material/CssBaseline';
// @ts-ignore
import { StyledEngineProvider } from '@mui/material/styles';
// @ts-ignore
import { createTheme } from '@mui/material/styles';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './config/firebase.config';
import ErrorBoundary from './components/ErrorBoundary'; // Importer l'Error Boundary

if (process.env.NODE_ENV === 'production') {
  console.log = () => undefined;
  console.debug = () => undefined;
  console.info = () => undefined;
}

/*
// Script global pour empêcher le masquage des éléments essentiels
// Cette fonction est exécutée immédiatement pour protéger les éléments UI
(function() {
  // Remplacer la méthode querySelectorAll pour protéger certains éléments
  const originalQuerySelectorAll = Document.prototype.querySelectorAll;
  Document.prototype.querySelectorAll = function(selector) {
    if (selector && typeof selector === 'string' && selector.includes('background: linear-gradient')) {
      const safeSelector = selector + ':not(button):not(.MuiButton-root):not(.MuiPaper-root):not(.mobile-pwa-page)';
      return originalQuerySelectorAll.call(this, safeSelector);
    }
    return originalQuerySelectorAll.call(this, selector);
  };
})();
*/

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#2e7d32', // Vert foncé de Material UI
    },
  },
});

// Composant racine simplifié pour la version publique
const RootComponent = () => {
  return (
    // @ts-ignore
    <React.StrictMode>
      {/* @ts-ignore */}
      <ErrorBoundary> {/* Envelopper l'application avec ErrorBoundary */}
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ThemeProvider>
        </StyledEngineProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<RootComponent />);

// Version publique simplifiée - pas besoin de mesurer les performances
// reportWebVitals();
